export default __webpack_public_path__ + "static/eidas-c21b588547dea7ef1654626d0ffbb2e3.png";